import { Flex, H1, Icon, StyledLink } from "orcs-design-system";
import React from "react";

import icons from "src/config/icons";
import { copywriting } from "src/components/ErrorPage/ErrorPage.config";
import { shouldUseHomePage } from "src/util/featureFlags";
import URL, { url } from "src/consts/urlPaths";
import { useUserPerson } from "src/contexts/global/GlobalContext";
import ErrorPageWrapper from "./ErrorPageWrapper";

const NotFoundError = () => {
  const userPerson = useUserPerson();

  const useHomePage = shouldUseHomePage(userPerson);

  return (
    <ErrorPageWrapper showIcon={false}>
      <H1>{copywriting.notFoundHeading}</H1>
      <Flex alignItems="center" gap="r">
        {useHomePage && (
          <StyledLink
            white
            href={url(URL.DIRECTORY_USER_HOME_BASE_PATH)}
            button
          >
            <Icon icon={icons.home} />
            {copywriting.backHomeButton}
          </StyledLink>
        )}
        <StyledLink white href={url(URL.EXPLORE)} button>
          <Icon icon={icons.search} />
          {copywriting.exploreButton}
        </StyledLink>
      </Flex>
    </ErrorPageWrapper>
  );
};

export default NotFoundError;
